import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { KOREAN_BANK_VALUES } from '@repo/shared'

interface BankOption {
  value: string
  label: string
}

export function useBankOptions(): BankOption[] {
  const { t } = useTranslation()

  return useMemo(
    () => KOREAN_BANK_VALUES.map((bank) => ({ value: bank, label: t(`common.banks.${bank}`) })),
    [t],
  )
}
